import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import copy from 'copy-to-clipboard';
import React, { useEffect, useState } from 'react';
import { showMessage } from 'src/shared/AppUtils';
import styled from 'styled-components';
import { getRecordContentApi } from './ApiService';

const Wrapper = styled.div``;

const CustomIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 0;
  cursor: pointer;
`;

function Marc21({ id }) {
  const [marc21, setMarc21] = useState([]);

  const getConent = () => {
    const params = { id, type: 'marc' };
    getRecordContentApi(params).then((data) => setMarc21(data));
  };

  const handleCopy = () => {
    copy(marc21.reduce((acc, curr) => (acc ? `${acc}\n${curr}` : curr), ''));
    showMessage('Thông báo', 'Nội dung Marc21 đã được lưu trong clipboard');
  };

  useEffect(() => {
    getConent();
  }, []);

  return (
    <Wrapper>
      <CustomIcon onClick={handleCopy} icon={faCopy} />
      {marc21.map((item) => (
        <div key={item}>{item}</div>
      ))}
    </Wrapper>
  );
}

export default Marc21;
